/**
 * Copy da Home no domínio dos anúncios (consultamais.org).
 *
 * Histórico (docs/ads/politica-medicamentos-controlados.md, 09–10/07/2026):
 * o classificador "Serviços de medicamentos controlados" do Google Ads
 * disparou com a combinação "receba receitas" / "receitas médicas online"
 * / links "exemplo de receita" na landing do .org. A regra que ficou:
 * não reintroduzir "receita" nem "medicamento" nos assets do .org.
 * O .app pode (e deve) continuar falando de receita — SEO e clareza.
 */

export const ORG_ADS_HOME_CTA = 'Iniciar consulta agora';

/** Mesmo subtítulo da Home do .app, sem "receita". */
export const ORG_SAFE_BRAND_SUB =
  'Fale diretamente com um médico e receba, quando indicado, atestado, pedido de exame ou encaminhamento — em PDF, com validade em todo o Brasil.';

export const ORG_SAFE_SEO_DESCRIPTION =
  'Teleconsulta médica por chat (sem videochamada) com médico real (CFM). Atestado, pedido de exame e encaminhamento em PDF, assinados digitalmente (ICP-Brasil), válidos em todo o Brasil. Resolução CFM 2.314/2022.';

export function textLooksLikeAdsDrugTrigger(text) {
  return /receita|medicamento|prescri[cç]/i.test(String(text || ''));
}

/** FAQ do carrossel da Home, sem os cartões/frases que o Ads já flagou. */
export function orgSafeCarouselCards(cards) {
  return (cards || [])
    .filter((card) => !textLooksLikeAdsDrugTrigger(card.title || ''))
    .map((card) => ({
      ...card,
      lines: (card.lines || []).map((line) => {
        if (!textLooksLikeAdsDrugTrigger(line)) return line;
        return String(line)
          .replace(/atestados e receitas emitidos/gi, 'atestados emitidos')
          .replace(/Atestado, receita e pedido de exame/gi, 'Atestado, pedido de exame e encaminhamento')
          .replace(/receitas? e /gi, '')
          .replace(/ e receitas?/gi, '')
          .replace(/,? receita/gi, '');
      }),
    }))
    .filter((card) => !textLooksLikeAdsDrugTrigger(`${card.title} ${(card.lines || []).join(' ')}`));
}

export function orgSafeReviews(reviews) {
  return (reviews || []).filter(
    (r) => !textLooksLikeAdsDrugTrigger(`${r.title || ''} ${r.text || ''}`),
  );
}
